module.exports = __webpack_public_path__ + "img/img-circle-back.37dc269a.png";